import {useToast} from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';

const $toast = useToast();

export function toastSuccess(msg){
    $toast.success(msg,{
        position: "bottom"
    })
}

export function toastError(msg){
    $toast.error(msg,{
        position: "bottom"
    })
}